import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Swipe from 'react-easy-swipe';

import {
  toggleLightbox,
  setLightboxImage,
} from '../../actions/lightbox';

import iconLeft from '../../images/icons/icon_72_leftchev.png';
import iconRight from '../../images/icons/icon_72_rightchev.png';
import iconClose from '../../images/icons/icon_32_close.png';

class Lightbox extends Component {
  constructor(props) {
    super(props);
    this.lightboxRef = React.createRef();
    this.changePage = this.changePage.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidUpdate() {
    const { isOpen } = this.props;
    if(isOpen) {
      this.lightboxRef.current.focus();
    }
  }

  changePage(val) {
    const {
      setLightboxImage,
      imgId,
      galleries,
      selectedGallery
    } = this.props;
    const currGallery = galleries[selectedGallery];
    if(imgId + val >= currGallery.length || imgId + val < 0) {
      return;
    }
    const newImg = currGallery[imgId + val];
    setLightboxImage(selectedGallery, newImg.id, newImg.imgSrc, newImg.imgAlt);
  }

  handleKeyPress(e) {
    if(e.key === 'ArrowLeft') {
      this.changePage(-1);
    } else if(e.key === 'ArrowRight') {
      this.changePage(1);
    }
  }

  render() {
    const {
      imgId,
      imgSrc,
      imgAlt,
      videoSrc,
      isYoutube,
      isOpen,
      isVideo,
      galleries,
      toggleLightbox,
      selectedGallery
    } = this.props;

    const currImage = imgId + 1;
    const currGallery = galleries[selectedGallery];
    if(isOpen) {
      return (
        <Swipe
          onSwipeRight={() => this.changePage(-1)}
          onSwipeLeft={() => this.changePage(1)}
          tolerance={100}
        >
          <div
            className="fe-lightbox"
            onKeyDown={this.handleKeyPress}
            ref={this.lightboxRef}
            tabIndex="0"
          >
            <div className="fe-lightbox-overlay"
              onClick={ () => toggleLightbox(false) }
            />
            <div className="fe-lightbox-close"
              onClick={ () => toggleLightbox(false) }
            >
              <img src={iconClose} alt=""/>
            </div>
            <div
              className="fe-lightbox-img-container"
            >
              {!isVideo ?
                <>
                  <div className={`fe-lightbox-btn left ${currImage <= 1 ? 'fe-hide' : ''}`}>
                    <img
                      src={iconLeft}
                      alt=""
                      onClick={ () => this.changePage(-1) }
                    />
                  </div>
                  <div className={`fe-lightbox-btn right ${currImage >= currGallery.length ? 'fe-hide' : ''}`}>
                    <img
                      src={iconRight}
                      alt=""
                      onClick={ () => this.changePage(1) }
                    />
                  </div>
                  <div className="fe-lightbox-controls">
                    <div className="fe-lightbox-page">
                      {`${currImage} / ${currGallery.length}`}
                    </div>
                  </div>
                </> : null}
              {!isVideo ?
                <div className={`fe-lightbox-img ${isVideo ? 'fe-hide' : ''}`}>
                  <img src={imgSrc} alt={imgAlt} />
                </div> : null }
              {isVideo ?
                (<div className={`fe-lightbox-vid ${isVideo ? '' : 'fe-hide'}`}>
                  {isYoutube ?
                    (<div className="video-responsive">
                      <iframe
                        width="853"
                        height="480"
                        src={videoSrc}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Full Video"
                      />
                    </div>) :
                    (<video autoPlay playsInline controls>
                      <source src={videoSrc} type="video/mp4" />
                    </video>)
                  }
                </div>) : null }
            </div>
          </div>
        </Swipe>
      );
    }
    return null;
  }
}

Lightbox.propTypes = {
  imgId: PropTypes.number,
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  isVideo: PropTypes.bool.isRequired,
  videoSrc: PropTypes.string.isRequired,
  isYoutube: PropTypes.bool,
  toggleLightbox: PropTypes.func.isRequired,
  galleries: PropTypes.object.isRequired,
  selectedGallery: PropTypes.string.isRequired,
  setLightboxImage: PropTypes.func.isRequired,
};

const mapStateToProps = ({ lightboxState }) => ({
  imgId: lightboxState.imgId,
  imgSrc: lightboxState.imgSrc,
  imgAlt: lightboxState.imgAlt,
  isOpen: lightboxState.isOpen,
  isVideo: lightboxState.isVideo,
  videoSrc: lightboxState.videoSrc,
  isYoutube: lightboxState.isYoutube,
  galleries: lightboxState.galleries,
  selectedGallery: lightboxState.selectedGallery,
});

const mapDispatchToProps = {
  toggleLightbox,
  setLightboxImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Lightbox);
